<template>
  <div class="sun SectionTitle">
    <div class="logo slow delay-500ms" v-inview:animate="'fadeIn'">
      <img src="@/assets/images/main/SectionTitle/logo.svg" alt="로고" />
    </div>
    <div class="subtitle slow delay-500ms" v-inview:animate="'fadeIn'">
      카드가맹점 전용
    </div>
    <div class="title slow delay-500ms" v-inview:animate="'fadeIn'">마이너스 통장</div>
    <div class="phone slow delay-500ms" v-inview:animate="'fadeInUp'">
      <div class="phone1">
        <div class="phone2">
          <div class="phone3">
            <div class="content">
              <div class="header">
                <div class="logo">
                  <img src="@/assets/images/logo-logo-fundanow-bb.svg" alt="funda-now-logo"/>
                </div>
                <div class="mypage">
                  <div>
                    나의정보
                  </div>
                </div>
              </div>
              <div class="profile">
                <div class="image">
                  <div class="profileimage">
                    <img class="b-img" src="@/assets/images/pirate/profile.svg">
                  </div>
                </div>
                <div class="statustext">
                  안녕하세요, <b>{{displayingName}} 사장님!</b> 지금부터 <b>비상금 신청</b>이 가능합니다.
                </div>
              </div>
              <div class="money">
                <img class="image-left" src="@/assets/images/dashboard/flower-left.svg">
                <img class="image-right" src="@/assets/images/dashboard/flower-right.svg">
                <!--문구-->
                <div class="text-money">
                  신청가능 비상금
                </div>
                <!--금액-->
                <div class="amount">
                  <span>
                    <ICountUp :endVal="displayingAmount"/>
                  </span>원
                </div>
              </div>
              <div class="button">
                <button @click="apply">
                  지금 <b>비상금 신청</b>하기
                </button>
              </div>
              <div class="text">
                현재 <b><ICountUp :endVal="countStore"/>명</b>이 비상금을 사용하고 있습니다.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loanApi from '@/api/now/loanApi'

export default {
  name: 'SectionTitle',
  components: {
  },
  props: ['name', 'amount'],
  data: function () {
    return {
      countStore: 0,
    }
  },
  computed: {
    moneyText: function () {
      return '신청가능 비상금'
    },
    displayingName: function () {
      return this.name || ''
    },
    displayingAmount: function () {
      return Number(this.amount) || 3000000
    }
  },
  async created() {
    let { data } = await loanApi.getLoanCount()
    this.countStore = data.fundaloan + data.easyloan
  },
  destroyed() {},
  methods: {
    apply() {
      this.$emit('apply')
    }
  },
}
</script>

<style lang="scss" scoped>
  .SectionTitle {
    width: 100%;
    background-image: linear-gradient(146deg, #15b1ff, #0ba0ff 99%);
    padding-top: 42px;
    display: flex !important;
    flex-direction: column;
    overflow: hidden;

    .logo {
      display: flex !important;
      align-items: center;
      justify-content: center;
    }

    .subtitle {
      font-size: 22px;
      font-weight: 300;
      line-height: 2.09;
      letter-spacing: -0.28px;
      text-align: center;
      color: #ffffff;
      margin-top: 27px;
    }

    .title {
      font-weight: 800;
      font-size: 41px;
      line-height: 1.12;
      letter-spacing: -0.4px;
      text-align: center;
      color: #ffffff;
    }

    .phone {
      position: relative;
      margin-top: 30px;
      display: flex !important;
      align-items: center;
      justify-content: center;
      .phone1 {
        width: calc(250% / 375 * 100);
        max-width: 360px;
        .phone2 {
          width: 100%;
          padding-top: calc(323% / 250 * 100);
          .phone3 {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            border-top-left-radius: 28px;
            border-top-right-radius: 28px;
            box-shadow: 12px 12px 20px 0 rgba(0, 0, 0, 0.15);
            background-color: #ffffff;
            display: flex;
            justify-content: center;
          }
        }
      }
    }

    .content {
      width: calc(240% / 250 * 100);
      height: calc(100% - 35px);
      margin-top: 35px;
      padding: 0px 16px;
      .header {
        height: 39px;
        display: block;
        .logo {
          float: left;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 96px;
          }
        }
        .mypage {
          float: right;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          div {
            width: 59px;
            height: 20px;
            font-size: 10px;
            color: #1baaf1;
            background: #f4faff;
            border-radius: 14.5px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
      .profile {
        height: 33px;
        margin-top: 12px;
        .image {
          float: left;
          width: 33px;
          height: 100%;
          .profileimage {
            width: 100%;
            height: 100%;
            border-radius: 100%;
            background: #1baaf1;
            img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
        }
        .statustext {
          float: right;
          width: calc(100% - 42px);
          height: 32px;
          font-size: 11px;
          line-height: 1.45;
          letter-spacing: -0.36px;
          color: #727d8c;
          b {
            font-weight: 900;
          }
        }
      }
      .money {
        margin-top: 30px;
        height: 83px;
        .image-left {
          position: absolute;
          left: 0;
          top: 0;
          width: 51px;
        }
        .image-right {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 43px;
        }

        .text-money {
          font-weight: 700;
          font-size: 14px;
          letter-spacing: -0.25px;
          text-align: center;
          color: #333333;
          padding-top: 19px;
        }

        .amount {
          font-weight: 900;
          font-size: 30px;
          letter-spacing: -0.41px;
          text-align: center;
          color: #333333;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .button {
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        button {
          width: 184px;
          height: 100%;
          border-radius: 14.8px;
          font-size: 12px;
          font-weight: 700;
          color: white;
          background-color: #1baaf1;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
          b {
            font-weight: 900;
            margin-left: 3px;
          }
        }
      }
      .text {
        margin-top: 9px;
        font-size: 11px;
        letter-spacing: -0.19px;
        text-align: center;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        b {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: row;
        }
      }
    }

  }
</style>
